import {Drawer, DrawerProps, ScrollArea} from '@mantine/core';
import {CreateForm} from '../forms/CreateForm.tsx';

export const FormDrawer = (
    {
        opened,
        onClose,
        ...rest
    }: DrawerProps) => {

    const title = 'Add Provider Mapping';

    return (
        <Drawer
            transitionProps={{
                transition: "slide-left",
                duration: 750,
                timingFunction: "ease"
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <CreateForm onSuccess={onClose}/>
        </Drawer>
    )
};
